import React from 'react';
import PropTypes from 'prop-types';

import WithActivityMetaTags from '../DataHOCs/WithActivityMetaTags';

const propTypes = {
    className: PropTypes.string,
    activityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    canEdit: PropTypes.bool,
    orgActMetaTags: PropTypes.object.isRequired,
    actMetaTagCategories: PropTypes.object.isRequired,
    orgActMetaTypes: PropTypes.array.isRequired,
    attachedMetaTags: PropTypes.object.isRequired,
    attachedMetaType: PropTypes.object.isRequired,
};

const defaultProps = {
    className: '',
    canEdit: false,
};

function ActivityMetaTagsEditor(props) {
    return (
        <div className={props.className}>
            {Object.keys(props.actMetaTagCategories).map((actMetaTagCategoryId) =>
                <ActivityMetaTagsForCategoryEditor
                    key={actMetaTagCategoryId}
                    id={`category${actMetaTagCategoryId}`}
                    className="margin-bottom-lg"
                    activityId={props.activityId}
                    canEdit={props.canEdit}
                    category={props.actMetaTagCategories[actMetaTagCategoryId]}
                    orgActMetaTags={props.orgActMetaTags[actMetaTagCategoryId]}
                    attachedTagsForCategory={props.attachedMetaTags[actMetaTagCategoryId] || {}}
                />
            )}
            <ActivityMetaTypeEditor
                id="category-act-type"
                className="margin-bottom-lg"
                activityId={props.activityId}
                canEdit={props.canEdit}
                orgActMetaTypes={props.orgActMetaTypes}
                attachedType={props.attachedMetaType}
            />
        </div>
    );
}

ActivityMetaTagsEditor.propTypes = propTypes;
ActivityMetaTagsEditor.defaultProps = defaultProps;

export default WithActivityMetaTags(ActivityMetaTagsEditor);

// -----------------------------------------------------------------

const uuid = require('uuid');
const sortBy = require('lodash/sortBy');
const reject = require('lodash/reject');
const filter = require('lodash/filter');
const map = require('lodash/map');
import { Button, Card } from 'react-bootstrap';

const Globals = require('../../../../app/globals');
const Strings = require('../../../../app/shared/Strings');
const ScrollUtil = require('../../util/ScrollUtil');
const ActivityStore = require('../../stores/activity_store_reflux');
const ActivityActions = require('../../actions/ActivityActions');
import FilterBox from '../common/FilterBox';
import AccessibleIcon from '../common/AccessibleIcon';
import ErrorBox from '../common/ErrorBox';

const catEditorPropTypes = {
    id: PropTypes.string.isRequired, // for anchor navigation from OrgActMetaTagEditor links
    className: PropTypes.string,
    activityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    canEdit: PropTypes.bool,
    category: PropTypes.object.isRequired,
    orgActMetaTags: PropTypes.object.isRequired,
    attachedTagsForCategory: PropTypes.object.isRequired,
}
const catEditorDefaultProps = {
    className: '',
    canEdit: false,
};
const OPT_PLACEHOLDER_VAL = 'null_placeholder';

class ActivityMetaTagsForCategoryEditor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            error: null,
            addMetaTagByIdActionId: null,
            addFreeFormMetaTagActionId: null,
            removeMetaTagActionId: null,
            inUseTagFilter: '',
            unusedTagFilter: '',
            newFreeFormTag: '',
            selectedUnusedTags: [],
            selectedInUseTags: [],
        };

        this.onInUseFilterChange = this.onInUseFilterChange.bind(this);
        this.onUnusedFilterChange = this.onUnusedFilterChange.bind(this);
        this.onNewFreeFormTagChange = this.onNewFreeFormTagChange.bind(this);
        this.onAddMetaTagById = this.onAddMetaTagById.bind(this);
        this.onAddFreeFormMetaTag = this.onAddFreeFormMetaTag.bind(this);
        this.onRemoveMetaTag = this.onRemoveMetaTag.bind(this);
        this.onRemoveMultiMetaTag = this.onRemoveMultiMetaTag.bind(this);
        this.onChangeUnusedTags = this.onChangeUnusedTags.bind(this);
        this.onChangeInUseTags = this.onChangeInUseTags.bind(this);
        this.onRemoveById = this.onRemoveById.bind(this);
        this.onAddById = this.onAddById.bind(this);
        this.onAddFreeForm = this.onAddFreeForm.bind(this);
        this.unsubscribes = [
            ActivityStore.listen(this.onActivityStoreChange.bind(this)),
        ];
    }

    componentDidMount() {
        ScrollUtil.scrollToUsingHash();
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onInUseFilterChange(e) {
        this.setState({ inUseTagFilter: e.target.value });
    }

    onUnusedFilterChange(e) {
        this.setState({ unusedTagFilter: e.target.value });
    }

    onNewFreeFormTagChange(e) {
        this.setState({ newFreeFormTag: e.target.value });
    }

    onActivityStoreChange(newState) {
        let updatedState = {};
        if (newState.action.id === this.state.addMetaTagByIdActionId) {
            updatedState = {
                addMetaTagByIdActionId: null,
                error: newState.action.error || null,
            };

            if (!newState.action.error) {
                updatedState = { ...updatedState, selectedUnusedTags: [] };
            }
        }

        if (newState.action.id === this.state.addFreeFormMetaTagActionId) {
            updatedState = {
                addFreeFormMetaTagActionId: null,
                error: newState.action.error || null,
            };

            if (!newState.action.error) {
                updatedState = { ...updatedState, newFreeFormTag: '' };
            }
        }

        if (newState.action.id === this.state.removeMetaTagActionId) {
            updatedState = {
                removeMetaTagActionId: null,
                error: newState.action.error || null,
            };

            if (!newState.action.error) {
                updatedState = { ...updatedState, selectedInUseTags: [] };
            }
        }

        this.setState(updatedState);
    }

    onAddMetaTagById(tagId) {
        const addMetaTagByIdActionId = uuid.v4();
        this.setState({ addMetaTagByIdActionId: addMetaTagByIdActionId }, () => {
            ActivityActions.addActMetaTagToActById(
                addMetaTagByIdActionId,
                {
                    actId: this.props.activityId,
                    tagId: tagId,
                }
            );
        });
    }

    onAddMultiMetaTagById(tagIds) {
        const addMetaTagByIdActionId = uuid.v4();
        this.setState({ addMetaTagByIdActionId: addMetaTagByIdActionId }, () => {
            ActivityActions.addActMetaTagsToActByIds(
                addMetaTagByIdActionId,
                {
                    actId: this.props.activityId,
                    tagIds: tagIds,
                }
            );
        });
    }

    onAddFreeFormMetaTag(newTag) {
        const addFreeFormMetaTagActionId = uuid.v4();
        this.setState({ addFreeFormMetaTagActionId: addFreeFormMetaTagActionId }, () => {
            ActivityActions.addFreeFormActMetaTagToAct(
                addFreeFormMetaTagActionId,
                {
                    actId: this.props.activityId,
                    categoryId: this.props.category.id,
                    tag: newTag,
                }
            );
        });
    }

    onRemoveMetaTag(tagId) {
        const removeMetaTagActionId = uuid.v4();
        this.setState({ removeMetaTagActionId: removeMetaTagActionId }, () => {
            ActivityActions.removeActMetaTagFromActById(
                removeMetaTagActionId,
                {
                    actId: this.props.activityId,
                    categoryId: this.props.category.id,
                    tagId: tagId,
                }
            );
        });      
    }

    onRemoveMultiMetaTag(tagIds) {
        const removeMetaTagActionId = uuid.v4();
        this.setState({ removeMetaTagActionId: removeMetaTagActionId }, () => {
            ActivityActions.removeActMetaTagsFromActByIds(
                removeMetaTagActionId,
                {
                    actId: this.props.activityId,
                    categoryId: this.props.category.id,
                    tagIds: tagIds,
                }
            );
        });      
    }

    onChangeUnusedTags(e) {
        const options = e.target.options;
        const selectedUnusedTags = [];
        if (this.props.category.allow_multiple) {
            for (let i = 0; i < options.length; i++) {
                if (
                    options[i].selected
                    && options[i].value !== OPT_PLACEHOLDER_VAL  // check value to ensure that selection isn't 'none found' placeholder option
                ) {
                    selectedUnusedTags.push(options[i].value);
                }
            }
        }
        else {
            const selectedIndex = options.selectedIndex;
            if (
                options[selectedIndex].selected && 
                options[selectedIndex].value !== OPT_PLACEHOLDER_VAL // check value to ensure that selection isn't 'none found' placeholder option
            ) {
                    selectedUnusedTags.push(options[selectedIndex].value);
            }
        }

        this.setState({ selectedUnusedTags: selectedUnusedTags });
    }

    onChangeInUseTags(e) {
        const options = e.target.options;
        let selectedInUseTags = [];
        for (let i = 0; i < options.length; i++) {
            if (
                options[i].selected
                && options[i].value !== OPT_PLACEHOLDER_VAL  // check value to ensure that selection isn't 'none found' placeholder option
            ) {
                selectedInUseTags.push(options[i].value);
            }
        }

        this.setState({ selectedInUseTags: selectedInUseTags });
    }

    onRemoveById() {
        if (this.state.selectedInUseTags.length === 0) {
            return;
        }
        else if (this.state.selectedInUseTags.length === 1) {
            this.onRemoveMetaTag(this.state.selectedInUseTags[0]);
        }
        else {
            this.onRemoveMultiMetaTag(this.state.selectedInUseTags);
        }
        
    }

    onAddById() {
        if (this.state.selectedUnusedTags.length === 0) {
            return;
        }
        else if (this.state.selectedUnusedTags.length === 1) {
            this.onAddMetaTagById(this.state.selectedUnusedTags[0]);
        }
        else {
            this.onAddMultiMetaTagById(this.state.selectedUnusedTags);
        }
    }

    onAddFreeForm() {
        if (!this.state.newFreeFormTag) {
            return;
        }
        else {
            this.onAddFreeFormMetaTag(this.state.newFreeFormTag);
        }
    }

    render() {
        const self = this;
        let filteredInUseTags;
        let filteredUnusedTags;
        if (this.state.inUseTagFilter) {
            filteredInUseTags = filter(this.props.attachedTagsForCategory, metaTag => metaTag.tag.toLowerCase().indexOf(this.state.inUseTagFilter.toLowerCase()) >= 0);
        }
        else {
            filteredInUseTags = map(this.props.attachedTagsForCategory, metaTag => metaTag); // obj -> array
        }

        if (this.state.unusedTagFilter) {
            filteredUnusedTags = filter(this.props.orgActMetaTags, metaTag => metaTag.tag.toLowerCase().indexOf(this.state.unusedTagFilter.toLowerCase()) >= 0);
        }
        else {
            filteredUnusedTags = map(this.props.orgActMetaTags, metaTag => metaTag); // obj -> array
        }

        let sortedInUseTags;
        let sortedUnusedTags;
        if (this.props.category.requires_order) {
            sortedInUseTags = sortBy(filteredInUseTags, metaTag => metaTag.display_order);
            sortedUnusedTags = sortBy(reject(filteredUnusedTags, metaTag => !!self.props.attachedTagsForCategory[metaTag.id]), metaTag => metaTag.display_order);
        }
        else {
            sortedInUseTags = sortBy(filteredInUseTags, metaTag => metaTag.tag.toLowerCase());
            sortedUnusedTags = sortBy(reject(filteredUnusedTags, metaTag => !!self.props.attachedTagsForCategory[metaTag.id]), metaTag => metaTag.tag.toLowerCase());
        }

        const numInUseTags = Object.keys(this.props.attachedTagsForCategory).length;
        let addButtonDisabled = false;
        if (
            !!this.state.addMetaTagByIdActionId
            || this.state.selectedUnusedTags.length === 0
            || (!this.props.category.allow_multiple
                && (
                    numInUseTags !== 0
                    || this.state.selectedUnusedTags.length > 1
                )
            )
        ) {
            addButtonDisabled = true;
        }

        let addFreeFormButtonDisabled = false;
        if (
            !this.state.newFreeFormTag
            || (
                !this.props.category.allow_multiple
                && numInUseTags !== 0
            )
        ) {
            addFreeFormButtonDisabled = true;
        }

        let removeButtonDisabled = false;
        if (
            !!this.state.removeMetaTagActionId
            || this.state.selectedInUseTags.length === 0
        ) {
            removeButtonDisabled = true;
        }

        return (
            <Card className={this.props.className} body bg="light">
                <a id={this.props.id} name={`#${this.props.id}`} />
                <h2 className="large-heading-regular margin-bottom-md">
                    {Strings['en'].act_meta_tags.CATEGORY}: <strong className="font-weight-bold">{this.props.category.display_name}</strong>
                </h2>
                <ul className="metaTagEditorCategoryDesc">
                    {this.props.category.type === Globals.activity_meta_tag.category_type.FREE_FORM &&
                        <li>{Strings['en'].act_meta_tags.CATEGORY_FREE_FORM_TYPE_DESC}</li>
                    }
                    {this.props.category.type === Globals.activity_meta_tag.category_type.ORG_CONTROLLED &&
                        <li>{Strings['en'].act_meta_tags.CATEGORY_ORG_CONTROLLED_TYPE_DESC}</li>
                    }
                    {this.props.category.allow_multiple ?
                        <li>{Strings['en'].act_meta_tags.CATEGORY_ALLOW_MULT_DESC}</li>
                        :
                        <li>{Strings['en'].act_meta_tags.CATEGORY_DISALLOW_MULT_DESC}</li>
                    }
                </ul>
                <hr className="small hr-color-6" />
                <ErrorBox error={this.state.error} />
                <div className="metaTagEditorRow">
                    <div className="margin-bottom-md metaTagEditorCol--left">
                        <div className="metaTagSelectArea">
                            <div className="metaTagSelectArea__main">
                                <h3 className="md-heading regular margin-bottom-md">In Use</h3>
                                <FilterBox
                                    className="margin-bottom-md"
                                    inputId={`meta-tag-used-filter-${this.props.id}`}
                                    icon="fa fa-font"
                                    label="Filter"
                                    onChange={this.onInUseFilterChange}
                                    value={this.state.inUseTagFilter}
                                />
                                <select
                                    className="metaTagSelectArea__select"
                                    multiple
                                    value={this.state.selectedInUseTags}
                                    onChange={this.onChangeInUseTags}
                                >
                                    {sortedInUseTags.map((metaTag) => 
                                        <option
                                            key={metaTag.id}
                                            value={metaTag.id}
                                        >
                                            {metaTag.tag}
                                        </option>
                                    )}
                                    {sortedInUseTags.length === 0 &&
                                        <option
                                            key="in-use-none"
                                            className="font-style-italic"
                                            value={OPT_PLACEHOLDER_VAL}
                                        >
                                            {!!this.state.inUseTagFilter ?
                                                Strings['en'].act_meta_tags.TAG_FILTER_NONE
                                                :
                                                Strings['en'].act_meta_tags.TAG_LIST_NONE
                                            }
                                        </option>
                                    }
                                </select>
                            </div>
                            <div className="metaTagControlButtons">
                                {this.props.canEdit &&
                                    <Button
                                        variant="danger"
                                        onClick={this.onRemoveById}
                                        disabled={removeButtonDisabled}
                                        title={Strings['en'].act_meta_tags.REMOVE_TAG_ACT}
                                    >
                                        <AccessibleIcon
                                            className="fa fa-remove"
                                            label={Strings['en'].act_meta_tags.REMOVE_TAG_ACT}
                                        />
                                    </Button>
                                }
                            </div>
                        </div>
                        {this.props.category.type === Globals.activity_meta_tag.category_type.FREE_FORM && this.props.canEdit &&
                            <div className="margin-top-lg">
                                <label>
                                    {Strings['en'].act_meta_tags.NEW_TAG}
                                    <input
                                        className="margin-left-md margin-right-md"
                                        type="text"
                                        value={this.state.newFreeFormTag}
                                        onChange={this.onNewFreeFormTagChange}
                                    />
                                </label>
                                <Button
                                    onClick={this.onAddFreeForm}
                                    disabled={addFreeFormButtonDisabled}
                                    title={Strings['en'].act_meta_tags.ADD_TAG_ACT}
                                >
                                    <AccessibleIcon
                                        className="fa fa-plus"
                                        label={Strings['en'].act_meta_tags.ADD_TAG_ACT} 
                                    />
                                </Button>
                            </div>
                        }
                    </div>
                    <div className="margin-bottom-md metaTagEditorCol--right">
                        <div className="metaTagSelectArea">
                            <div className="metaTagControlButtons">
                                {this.props.canEdit &&
                                    <Button
                                        onClick={this.onAddById}
                                        disabled={addButtonDisabled}
                                        title={Strings['en'].act_meta_tags.ADD_TAG_ACT}
                                    >
                                        <AccessibleIcon
                                            className="fa fa-plus"
                                            label={Strings['en'].act_meta_tags.ADD_TAG_ACT} 
                                        />
                                    </Button>
                                }
                            </div>
                            <div className="metaTagSelectArea__main">
                                <h3 className="md-heading regular margin-bottom-md">{Strings['en'].common.AVAILABLE}</h3>
                                <FilterBox
                                    className="margin-bottom-md"
                                    inputId={`meta-tag-unused-filter-${this.props.id}`}
                                    icon="fa fa-font"
                                    label="Filter"
                                    onChange={this.onUnusedFilterChange}
                                    value={this.state.unusedTagFilter}
                                />
                                <select
                                    className="metaTagSelectArea__select"
                                    multiple
                                    value={this.state.selectedUnusedTags}
                                    onChange={this.onChangeUnusedTags}
                                >
                                    {sortedUnusedTags.map((metaTag) => 
                                        <option
                                            key={metaTag.id}
                                            value={metaTag.id}
                                        >
                                            {metaTag.tag}
                                        </option>
                                    )}
                                    {sortedUnusedTags.length === 0 &&
                                        <option
                                            key="unused-none"
                                            className="font-style-italic"
                                            value={OPT_PLACEHOLDER_VAL}
                                        >
                                            {!!this.state.unusedTagFilter ?
                                                Strings['en'].act_meta_tags.TAG_FILTER_NONE
                                                :
                                                Strings['en'].act_meta_tags.TAG_LIST_NONE
                                            }
                                        </option>
                                    }
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </Card>
        );
    }
}

ActivityMetaTagsForCategoryEditor.catEditorPropTypes = catEditorPropTypes;
ActivityMetaTagsForCategoryEditor.catEditorDefaultProps = catEditorDefaultProps;

// -----------------------------------------------------------------

const typeCatEditorPropTypes = {
    id: PropTypes.string.isRequired, // for anchor navigation from OrgActMetaTagEditor links
    className: PropTypes.string,
    activityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    canEdit: PropTypes.bool,
    orgActMetaTypes: PropTypes.array.isRequired,
    attachedType: PropTypes.object.isRequired,
}
const typeCatEditorDefaultProps = {
    className: '',
    canEdit: false,
};
class ActivityMetaTypeEditor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            error: null,
            addMetaTypeByIdActionId: null,
            removeMetaTypeActionId: null,
            inUseTypeFilter: '',
            unusedTypeFilter: '',
            selectedUnusedTags: [],
            selectedInUseTypes: [],
        };

        this.onInUseFilterChange = this.onInUseFilterChange.bind(this);
        this.onUnusedFilterChange = this.onUnusedFilterChange.bind(this);
        this.onAddMetaTypeById = this.onAddMetaTypeById.bind(this);
        this.onRemoveMetaType = this.onRemoveMetaType.bind(this);
        this.onChangeUnusedTypes = this.onChangeUnusedTypes.bind(this);
        this.onChangeInUseType = this.onChangeInUseType.bind(this);
        this.onRemoveById = this.onRemoveById.bind(this);
        this.onAddById = this.onAddById.bind(this);
        this.unsubscribes = [
            ActivityStore.listen(this.onActivityStoreChange.bind(this)),
        ];
    }

    componentDidMount() {
        ScrollUtil.scrollToUsingHash();
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onInUseFilterChange(e) {
        this.setState({ inUseTypeFilter: e.target.value });
    }

    onUnusedFilterChange(e) {
        this.setState({ unusedTypeFilter: e.target.value });
    }

    onActivityStoreChange(newState) {
        let updatedState = {};
        if (newState.action.id === this.state.addMetaTypeByIdActionId) {
            updatedState = {
                addMetaTypeByIdActionId: null,
                error: newState.action.error || null,
            };

            if (!newState.action.error) {
                updatedState = { ...updatedState, selectedUnusedTags: [] };
            }
        }

        if (newState.action.id === this.state.removeMetaTypeActionId) {
            updatedState = {
                removeMetaTypeActionId: null,
                error: newState.action.error || null,
            };

            if (!newState.action.error) {
                updatedState = { ...updatedState, selectedInUseTypes: [] };
            }
        }

        this.setState(updatedState);
    }

    onAddMetaTypeById(typeId) {
        const addMetaTypeByIdActionId = uuid.v4();
        this.setState({ addMetaTypeByIdActionId: addMetaTypeByIdActionId }, () => {
            ActivityActions.addActMetaTypeToActById(
                addMetaTypeByIdActionId,
                {
                    actId: this.props.activityId,
                    typeId: typeId,
                }
            );
        });
    }

    onRemoveMetaType(typeId) {
        const removeMetaTypeActionId = uuid.v4();
        this.setState({ removeMetaTypeActionId: removeMetaTypeActionId }, () => {
            ActivityActions.removeActMetaTypeFromActById(
                removeMetaTypeActionId,
                {
                    actId: this.props.activityId,
                    typeId: typeId,
                }
            );
        });      
    }

    onChangeUnusedTypes(e) {
        const options = e.target.options;
        const selectedUnusedTags = [];

        const selectedIndex = options.selectedIndex;
        if (
            options[selectedIndex].selected && 
            options[selectedIndex].value !== OPT_PLACEHOLDER_VAL // check value to ensure that selection isn't 'none found' placeholder option
        ) {
                selectedUnusedTags.push(options[selectedIndex].value);
        }

        this.setState({ selectedUnusedTags: selectedUnusedTags });
    }

    onChangeInUseType(e) {
        const options = e.target.options;
        let selectedInUseTypes = [];
        for (let i = 0; i < options.length; i++) {
            if (
                options[i].selected
                && options[i].value !== OPT_PLACEHOLDER_VAL  // check value to ensure that selection isn't 'none found' placeholder option
            ) {
                selectedInUseTypes.push(options[i].value);
            }
        }

        this.setState({ selectedInUseTypes: selectedInUseTypes });
    }

    onRemoveById() {
        if (this.state.selectedInUseTypes.length === 0) {
            return;
        }
        else if (this.state.selectedInUseTypes.length === 1) {
            this.onRemoveMetaType(this.state.selectedInUseTypes[0]);
        }
    }

    onAddById() {
        if (this.state.selectedUnusedTags.length === 0) {
            return;
        }
        else if (this.state.selectedUnusedTags.length === 1) {
            this.onAddMetaTypeById(this.state.selectedUnusedTags[0]);
        }
        else {
            this.onAddMultiMetaTagById(this.state.selectedUnusedTags);
        }
    }

    render() {
        const self = this;
        const hasTypeInUse = !!this.props.attachedType.id;

        let filteredUnusedTypes;
        if (this.state.unusedTypeFilter) {
            filteredUnusedTypes = filter(this.props.orgActMetaTypes, metaType => metaType.type_display_name.toLowerCase().indexOf(this.state.unusedTypeFilter.toLowerCase()) >= 0);
        }
        else {
            filteredUnusedTypes = this.props.orgActMetaTypes;
        }

        let sortedUnusedTypes;
        if (hasTypeInUse) {
            sortedUnusedTypes = sortBy(reject(filteredUnusedTypes, metaType => metaType.id === self.props.attachedType.id), metaType => metaType.type_display_name.toLowerCase());
        }
        else {
            sortedUnusedTypes = sortBy(filteredUnusedTypes, metaType => metaType.type_display_name.toLowerCase());
        }

        let addButtonDisabled = false;
        if (
            !!this.state.addMetaTypeByIdActionId
            || this.state.selectedUnusedTags.length === 0
            || hasTypeInUse
            || this.state.selectedUnusedTags.length > 1
        ) {
            addButtonDisabled = true;
        }

        let removeButtonDisabled = false;
        if (
            !!this.state.removeMetaTypeActionId
            || this.state.selectedInUseTypes.length === 0
        ) {
            removeButtonDisabled = true;
        }

        return (
            <Card className={this.props.className} body bg="light">
                <a id={this.props.id} name={`#${this.props.id}`} />
                <h2 className="large-heading-regular margin-bottom-md">
                    {Strings['en'].act_meta_tags.CATEGORY}: <strong className="font-weight-bold">{Strings['en'].act_meta_types.ACTIVITY_TYPE}</strong>
                </h2>
                <ul className="metaTagEditorCategoryDesc">
                    <li>{Strings['en'].act_meta_types.CATEGORY_ORG_CONTROLLED_TYPE_DESC}</li>
                    <li>{Strings['en'].act_meta_types.CATEGORY_DISALLOW_MULT_DESC}</li>
                </ul>
                <hr className="small hr-color-6" />
                <ErrorBox error={this.state.error} />
                <div className="metaTagEditorRow">
                    <div className="margin-bottom-md metaTagEditorCol--left">
                        <div className="metaTagSelectArea">
                            <div className="metaTagSelectArea__main">
                                <h3 className="md-heading regular margin-bottom-md">In Use</h3>
                                <FilterBox
                                    className="margin-bottom-md"
                                    inputId={`meta-tag-used-filter-${this.props.id}`}
                                    icon="fa fa-font"
                                    label="Filter"
                                    onChange={this.onInUseFilterChange}
                                    value={this.state.inUseTypeFilter}
                                />
                                <select
                                    className="metaTagSelectArea__select"
                                    multiple
                                    value={this.state.selectedInUseTypes}
                                    onChange={this.onChangeInUseType}
                                >
                                    {(hasTypeInUse) &&
                                        <option
                                            key={this.props.attachedType.id}
                                            value={this.props.attachedType.id}
                                        >
                                            {this.props.attachedType.type_display_name}
                                        </option>
                                    }
                                    {(!hasTypeInUse) &&
                                        <option
                                            key="in-use-none"
                                            className="font-style-italic"
                                            value={OPT_PLACEHOLDER_VAL}
                                        >
                                            {(!!this.state.inUseTypeFilter) ?
                                                Strings['en'].act_meta_types.TYPE_FILTER_NONE
                                                :
                                                Strings['en'].act_meta_types.TYPE_LIST_NONE
                                            }
                                        </option>
                                    }
                                </select>
                            </div>
                            <div className="metaTagControlButtons">
                                {(this.props.canEdit) &&
                                    <Button
                                        variant="danger"
                                        onClick={this.onRemoveById}
                                        disabled={removeButtonDisabled}
                                        title={Strings['en'].act_meta_types.REMOVE_TYPE_ACT}
                                    >
                                        <AccessibleIcon
                                            className="fa fa-remove"
                                            label={Strings['en'].act_meta_types.REMOVE_TYPE_ACT}
                                        />
                                    </Button>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="margin-bottom-md metaTagEditorCol--right">
                        <div className="metaTagSelectArea">
                            <div className="metaTagControlButtons">
                                {(this.props.canEdit) &&
                                    <Button
                                        onClick={this.onAddById}
                                        disabled={addButtonDisabled}
                                        title={Strings['en'].act_meta_types.ADD_TYPE_ACT}
                                    >
                                        <AccessibleIcon
                                            className="fa fa-plus"
                                            label={Strings['en'].act_meta_types.ADD_TYPE_ACT} 
                                        />
                                    </Button>
                                }
                            </div>
                            <div className="metaTagSelectArea__main">
                                <h3 className="md-heading regular margin-bottom-md">{Strings['en'].common.AVAILABLE}</h3>
                                <FilterBox
                                    className="margin-bottom-md"
                                    inputId={`meta-tag-unused-filter-${this.props.id}`}
                                    icon="fa fa-font"
                                    label="Filter"
                                    onChange={this.onUnusedFilterChange}
                                    value={this.state.unusedTypeFilter}
                                />
                                <select
                                    className="metaTagSelectArea__select"
                                    multiple
                                    value={this.state.selectedUnusedTags}
                                    onChange={this.onChangeUnusedTypes}
                                >
                                    {sortedUnusedTypes.map((metaType) => 
                                        <option
                                            key={metaType.id}
                                            value={metaType.id}
                                        >
                                            {metaType.type_display_name}
                                        </option>
                                    )}
                                    {(sortedUnusedTypes.length === 0) &&
                                        <option
                                            key="unused-none"
                                            className="font-style-italic"
                                            value={OPT_PLACEHOLDER_VAL}
                                        >
                                            {!!this.state.unusedTypeFilter ?
                                                Strings['en'].act_meta_types.TYPE_FILTER_NONE
                                                :
                                                Strings['en'].act_meta_types.TYPE_LIST_NONE
                                            }
                                        </option>
                                    }
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </Card>
        );
    }
}

ActivityMetaTypeEditor.typeCatEditorPropTypes = typeCatEditorPropTypes;
ActivityMetaTypeEditor.typeCatEditorDefaultProps = typeCatEditorDefaultProps;